import * as yup from 'yup';
import { ProfessorModel } from './Model';
import { IValidator } from '../IValidator';

const professorSchema = yup.object().shape<ProfessorModel>({
  id: yup.number(),

  nome: yup.string()
    .required('Campo obrigatório'),

  cpf: yup.string()
    .required('CPF é obrigatório'),

  email: yup.string()
    .email('Formato do email incorreto')
    .required('Email é obrigatório'),

  telefone: yup.string()
    .nullable(),

  vagasPreProjeto: yup.number(),

  tipo: yup.number()
    .required(),

  ativo: yup.bool()
    .required(),

  ativoBanca: yup.bool()
    .required()
});

const dataHoraSchema = yup.object().shape({
  dataHora: yup
    .string()
    .typeError('Data inválida')
    .test('minuto', 'Horário inválido', (value: string) => Number(value.split(' ')[1].split(':')[1]) < 60)
    .test('hora', 'Hora inválido', (value: string) => Number(value.split(' ')[1].split(':')[0]) < 24)
    .test('ano', 'Ano inválido', (value: string) => new Date(value.split(' ')[0]).getFullYear() < 9999)
    .test('dataFutura', 'Data menor que a presente', (value: string) => new Date(value.split(' ')[0]) >= new Date(new Date().setDate(new Date().getDate() - 1)))
    .test('required', 'Data e hora são obrigatórios', (value: string) => value.replace(' ', '') !== '')
});

const agendamentoSchema = yup.object().shape({
  data: yup
    .string()
    .typeError('Data inválida')
    .test('minuto', 'Horário inválido', (value: string) => Number(value.split(' ')[1].split(':')[1]) < 60)
    .test('hora', 'Hora inválido', (value: string) => Number(value.split(' ')[1].split(':')[0]) < 24)
    .test('ano', 'Ano inválido', (value: string) => new Date(value.split(' ')[0]).getFullYear() < 9999)
    .test('dataFutura', 'Data menor que a presente', (value: string) => new Date(value.split(' ')[0]) >= new Date(new Date().setDate(new Date().getDate() - 1)))
    .test('required', 'Data e hora são obrigatórios', (value: string) => value.replace(' ', '') !== ''),

  //banca: yup.array().of(professorSchema),

  //suplentes: yup.array().of(professorSchema)
});

export const AgendamentoValidator = new IValidator<{ data: string, banca: ProfessorModel[], suplentes: ProfessorModel[] }>(agendamentoSchema);

export const ProfessorModelValidator = new IValidator<ProfessorModel>(professorSchema);
export const DataHoraValidator = new IValidator<{ dataHora: string }>(dataHoraSchema);